import React from 'react'
import { getColor } from 'components/utils'
import { TransProps } from '@lingui/react'


// Type
export type typeInputNumberLimit = {
    variant?: string
    id: string
    name?: string
    label?: React.ReactElement<TransProps>
    placeholder?: string
    value?: string
    setValue: React.Dispatch<React.SetStateAction<string>>
    errorMessage?: React.ReactElement<TransProps>
    required?: boolean
    autoFocus?: boolean
    onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void
    labelClassName?: string
    inputClassName?: string
    inputWrapClassName?: string
    digitsAfterDot?: number
    digitBeforeDot?: number
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void
    inputRef?: React.MutableRefObject<any>
}


// Component
export const InputNumberLimit: React.FC<typeInputNumberLimit> = ({
                                                                     variant,
                                                                     id,
                                                                     name,
                                                                     label,
                                                                     placeholder,
                                                                     value = '',
                                                                     setValue,
                                                                     errorMessage,
                                                                     required = false,
                                                                     autoFocus,
                                                                     onBlur,
                                                                     labelClassName,
                                                                     inputClassName,
                                                                     inputWrapClassName,
                                                                     digitsAfterDot = 0,
                                                                     digitBeforeDot = 17,

                                                                     onKeyDown,
                                                                     inputRef
                                                                 }) => {

    const color = getColor(variant)

    const labelStyles = [ 'block mb-1 text-sm font-medium text-gray-700', labelClassName ].join(' ')
    const inputStyles = [ `appearance-none block w-full px-3 py-2 border ${ errorMessage ? 'border-red-500' : 'border-gray-300' } rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-${ errorMessage ? 'red' : color }-500 focus:border-${ errorMessage ? 'red' : color }-500 sm:text-sm`, inputClassName ].join(' ')

    const maxLength = digitsAfterDot > 0 ? digitBeforeDot + 1 + digitsAfterDot : digitBeforeDot

    const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
        let newV = e.target.value
        if (newV.startsWith('.')) {
            newV = '0.' + newV.substring(1)
        }
        if (digitsAfterDot > 0) {
            newV = newV.split('').reduce((acc, curr) => curr.match(/[0-9.]/) ? acc + curr : acc, '')
            if (!newV.includes('.')) {
                if (newV.length > digitBeforeDot) {
                    newV = newV.substring(0, digitBeforeDot)
                }
            } else {
                const arr = newV.split('.')
                if (arr[1].length > digitsAfterDot) {newV = [ arr[0], '.', arr[1].substring(0, digitsAfterDot) ].join('')}
                if (newV.length > digitBeforeDot + digitsAfterDot + 1) {newV = newV.substring(0, digitBeforeDot + digitsAfterDot + 1) }
            }

        } else {
            if (newV.match(/\D/)) {
                newV = newV.replace(/\D/, '')
            }
            if (newV.length > digitBeforeDot) {newV = newV.substring(0, digitBeforeDot) }
        }


        setValue(newV)
    }

    return (
        <>
            { label
                ? <label
                    htmlFor={ id }
                    className={ labelStyles }
                >
                    { required && <span className="text-red-600 mr-1">*</span> } { label }
                </label>
                : null
            }

            <div className={ inputWrapClassName }>
                <input
                    id={ id }
                    name={ name }
                    type="text"
                    placeholder={ placeholder }
                    value={ value }
                    required={ required }
                    onChange={ onChangeHandler }
                    onKeyDown={ onKeyDown }
                    className={ inputStyles }
                    autoFocus={ autoFocus }
                    onBlur={ onBlur }
                    maxLength={ maxLength }
                    ref={ inputRef }
                />
                { errorMessage
                    ? <p className="text-xs mt-1 text-red-500">{ errorMessage }</p>
                    : null
                }
            </div>
        </>
    )
}
